import moment from 'moment';

import serviceTypeCodes from 'constants/serviceTypeCodes';
import { brandCode } from 'constants/brandCodes';

export const SNCB_UNCONFIRMED_TIMETABLE_BOOKING_START_DATE = '2026-06-13';
export const SNCB_UNCONFIRMED_TIMETABLE_BOOKING_END_DATE = '2026-09-28';
export const SNCB_UNCONFIRMED_TIMETABLE_TRAVEL_START_DATE = '2026-12-13';

const isSNCBLeg = ({ serviceType } = {}) => serviceType?.code === serviceTypeCodes.SNCB || serviceType?.brandCode === brandCode.SNCB;

const getStartOfDay = (date) => moment.utc(date, moment.ISO_8601).startOf('day');

const isOnOrAfterDate = (date, startDate) => {
  const parsedDate = getStartOfDay(date);
  const parsedStartDate = getStartOfDay(startDate);

  if (!parsedDate.isValid() || !parsedStartDate.isValid()) {
    return false;
  }

  return parsedDate.isSameOrAfter(parsedStartDate);
};

const isBetweenDates = (date, startDate, endDate) => {
  const parsedDate = getStartOfDay(date);
  const parsedStartDate = getStartOfDay(startDate);
  const parsedEndDate = getStartOfDay(endDate);

  if (!parsedDate.isValid() || !parsedStartDate.isValid() || !parsedEndDate.isValid()) {
    return false;
  }

  return parsedDate.isBetween(parsedStartDate, parsedEndDate, null, '[]');
};

const getLegDepartureDate = ({ timing = {} } = {}) => timing.departureDate || timing.isoDate || timing.date;

const isEligibleSNCBTravelLeg = (leg) =>
  isSNCBLeg(leg) && isOnOrAfterDate(getLegDepartureDate(leg), SNCB_UNCONFIRMED_TIMETABLE_TRAVEL_START_DATE);

const getSearchOffers = ({ outbound, inbound } = {}) => [outbound, inbound].filter(Boolean);

export const hasSNCBUnconfirmedTimetableSearchResults = (searchData = {}) =>
  getSearchOffers(searchData).some((offer) =>
    offer?.journeys?.some((journey) => journey?.fares?.some((fare) => fare?.legs?.some(isEligibleSNCBTravelLeg)))
  );

export const shouldShowSNCBUnconfirmedTimetableManageBookingBanner = (journey = {}) =>
  isEligibleSNCBTravelLeg(journey) &&
  journey.activeBookingItems?.some(
    ({ cancelled, isCancelled, confirmedTimestamp }) =>
      !cancelled &&
      !isCancelled &&
      isBetweenDates(confirmedTimestamp, SNCB_UNCONFIRMED_TIMETABLE_BOOKING_START_DATE, SNCB_UNCONFIRMED_TIMETABLE_BOOKING_END_DATE)
  );
